import {
  buildPackagingMinimisationPdfCoverMarkdown,
  formatCompliancePdfDate,
} from './buildPackagingMinimisationPdfCoverMarkdown'
import type { TFunction } from 'i18next'

export type BuildPackagingItemMinimisationAssessmentPdfCoverMarkdownParams = {
  translate: TFunction<'packagingSuppliers'>
  locale: string
  itemName: string
  itemDescription: string
  intendedUse: string
  packagingIdentificationNumber: string
  manufacturerName: string
  manufacturerAddress: string
  reportReferenceNo: string
  dateOfAssessmentIso: string | undefined
}

export function buildPackagingItemMinimisationAssessmentPdfCoverMarkdown(
  params: BuildPackagingItemMinimisationAssessmentPdfCoverMarkdownParams
): string {
  const prefix = 'itemDetail.minimisation.document.pdfCover'

  return buildPackagingMinimisationPdfCoverMarkdown({
    documentTitle: params.translate(`${prefix}.documentTitle`),
    subtitle: params.translate(`${prefix}.subtitle`),
    description: params.translate(`${prefix}.description`),
    labels: {
      reportReferenceNo: params.translate(`${prefix}.reportReferenceNo`),
      dateOfAssessment: params.translate(`${prefix}.dateOfAssessment`),
      packagingName: params.translate(`${prefix}.packagingName`),
      packagingDescription: params.translate(`${prefix}.packagingDescription`),
      packagingIdentificationNumber: params.translate(
        `${prefix}.packagingIdentificationNumber`
      ),
      intendedUse: params.translate(`${prefix}.intendedUse`),
      photoOfPackaging: params.translate(`${prefix}.photoOfPackaging`),
      company: params.translate(`${prefix}.manufacturerName`),
      companyAddress: params.translate(`${prefix}.manufacturerAddress`),
      standardsApplied: params.translate(`${prefix}.standardsApplied`),
      testProcedure: params.translate(`${prefix}.testProcedure`),
      numberOfPages: params.translate(`${prefix}.numberOfPages`),
      notAvailable: params.translate(`${prefix}.notAvailable`),
      preparedBy: params.translate(`${prefix}.preparedBy`),
      approvedBy: params.translate(`${prefix}.approvedBy`),
    },
    reportReferenceNo: params.reportReferenceNo,
    dateOfAssessment: params.dateOfAssessmentIso,
    packagingName: params.itemName,
    packagingDescription: params.itemDescription,
    packagingIdentificationNumber: params.packagingIdentificationNumber,
    intendedUse: params.intendedUse,
    companyName: params.manufacturerName,
    companyAddress: params.manufacturerAddress,
    standardsApplied: params.translate(`${prefix}.standardsAppliedValue`),
    testProcedure: params.translate(`${prefix}.testProcedureValue`),
    formatDate: (iso) => formatCompliancePdfDate(iso, params.locale),
    omitPhotoRow: true,
    omitNumberOfPagesRow: true,
  })
}
